__turbopack_context__.v({
  "backToSearch": "work-page-module-scss-module__o0TP6W__backToSearch",
  "backToSearchRow": "work-page-module-scss-module__o0TP6W__backToSearchRow",
  "belowMediumCurrentPrice": "work-page-module-scss-module__o0TP6W__belowMediumCurrentPrice",
  "belowMediumPrice": "work-page-module-scss-module__o0TP6W__belowMediumPrice",
  "belowMediumPriceLine": "work-page-module-scss-module__o0TP6W__belowMediumPriceLine",
  "belowMediumSavings": "work-page-module-scss-module__o0TP6W__belowMediumSavings",
  "belowSmallSocialLinks": "work-page-module-scss-module__o0TP6W__belowSmallSocialLinks",
  "breadcrumbChevron": "work-page-module-scss-module__o0TP6W__breadcrumbChevron",
  "breadcrumbs": "work-page-module-scss-module__o0TP6W__breadcrumbs",
  "byline": "work-page-module-scss-module__o0TP6W__byline",
  "collectibleIcon": "work-page-module-scss-module__o0TP6W__collectibleIcon",
  "collectibleLink": "work-page-module-scss-module__o0TP6W__collectibleLink",
  "cover": "work-page-module-scss-module__o0TP6W__cover",
  "coverColumn": "work-page-module-scss-module__o0TP6W__coverColumn",
  "coverSocialLinks": "work-page-module-scss-module__o0TP6W__coverSocialLinks",
  "details": "work-page-module-scss-module__o0TP6W__details",
  "identifiers": "work-page-module-scss-module__o0TP6W__identifiers",
  "mainColumn": "work-page-module-scss-module__o0TP6W__mainColumn",
  "otherWays": "work-page-module-scss-module__o0TP6W__otherWays",
  "otherWaysChevron": "work-page-module-scss-module__o0TP6W__otherWaysChevron",
  "otherWaysLabel": "work-page-module-scss-module__o0TP6W__otherWaysLabel",
  "otherWaysText": "work-page-module-scss-module__o0TP6W__otherWaysText",
  "product": "work-page-module-scss-module__o0TP6W__product",
  "purchase": "work-page-module-scss-module__o0TP6W__purchase",
  "root": "work-page-module-scss-module__o0TP6W__root",
  "selector": "work-page-module-scss-module__o0TP6W__selector",
  "seriesLine": "work-page-module-scss-module__o0TP6W__seriesLine",
  "titleBlock": "work-page-module-scss-module__o0TP6W__titleBlock",
  "titleIdentifiers": "work-page-module-scss-module__o0TP6W__titleIdentifiers",
  "u-animation-bounce": "work-page-module-scss-module__o0TP6W__u-animation-bounce",
});
